import { ComponentsOverrides, ComponentsProps, ComponentsVariants, Theme, buttonClasses } from '@mui/material';

import { getStatePalette } from '../helper/get-state-palette';

export const MuiButton: {
    styleOverrides: ComponentsOverrides<Theme>['MuiButton'];
    defaultProps?: ComponentsProps['MuiButton'];
    variants?: ComponentsVariants<Theme>['MuiButton'];
} = {
    styleOverrides: {
        root: ({ ownerState }) => ({
            padding: !ownerState.children ? 0 : undefined,
            minWidth: 40,
        }),
        outlined: ({ ownerState, theme }) => ({
            border: `1.5px solid ${getStatePalette(ownerState, theme).main}`,
            '&:hover': {
                border: `1.5px solid ${getStatePalette(ownerState, theme).main}`,
            },
        }),
        sizeMedium: {
            height: 40,
        },
        startIcon: ({ ownerState, theme }) => ({
            marginLeft: 0,
            margin: !ownerState.children ? 0 : theme.spacing(0, 1.5, 0, 0),
        }),
    },
    defaultProps: {
        variant: 'contained',
        size: 'medium',
    },
    variants: [
        {
            props: { variant: 'containedRound' },
            style: ({ theme }) => ({
                borderRadius: '50%',
                // From contained style https://github.com/mui/material-ui/blob/master/packages/mui-material/src/Button/Button.js
                '&:hover': {
                    backgroundColor: theme.palette['primary'].dark,
                    boxShadow: theme.shadows[4],
                    '@media (hover: none)': {
                        boxShadow: theme.shadows[2],
                        backgroundColor: theme.palette['primary'].main,
                    },
                },
                '&:active': {
                    boxShadow: theme.shadows[8],
                },
                [`&.${buttonClasses.focusVisible}`]: {
                    boxShadow: theme.shadows[6],
                },
                [`&.${buttonClasses.disabled}`]: {
                    color: theme.palette.action.disabled,
                    boxShadow: theme.shadows[0],
                    backgroundColor: theme.palette.action.disabledBackground,
                },
                color: theme.palette['primary'].contrastText,
                backgroundColor: theme.palette['primary'].main,
                boxShadow: theme.shadows[2],
            }),
        },
    ],
};

declare module '@mui/material/Button' {
    interface ButtonPropsVariantOverrides {
        containedRound: true;
    }
}

declare module '@mui/material/Button' {
    interface ButtonPropsColorOverrides {
        light: true;
        dark: true;
        medium: true;
    }
}
